import { defineMessages } from 'react-intl';

export const InventoryMeterOutputMessages = defineMessages({
  technology: {
    id: 'app.inventoryMeterOutput.technology',
  },
  remoteReadingOwner: {
    id: 'app.inventoryMeterOutput.remoteReadingOwner',
  },
  isOccupied: {
    id: 'app.inventoryMeterOutput.isOccupied',
  },
  output: {
    id: 'app.inventoryMeterOutput.output',
  },
  yes: {
    id: 'app.common.yes',
    defaultMessage: 'Ano',
  },
  no: {
    id: 'app.common.no',
    defaultMessage: 'Ne',
  },
});
